import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { EditPatientModalComponent } from './edit-patient-modal.component';

@NgModule({
  declarations: [EditPatientModalComponent],
  exports: [EditPatientModalComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class EditPatientModalModule {}
